module.exports = __webpack_public_path__ + "img/after8.a5b99ded.png";